/// <amd-module name="typeahead/features/CarPlaceholderCycle" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {prefetchInstance} from "typeahead/core/plugins/CompositePageLoadHandler";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "CarsLandingPage"],
    },
];

const configurationRandom: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "CarsLandingPage"],
    },
    {
        lobs: ["CARS"],
    },
];

export class CarPlaceholderCycle implements IPageLoadHandler {
    private static tryPhrase: string = loc.carPlaceholderCycleTryPhrase || 'Try "{0}"';
    private static placeholders: string[];
    private static initialDelayMillis: number = 1000;
    private static cycleDelayMillis: number = 2000;
    private static variant: number;
    private $input: JQuery =  $("input[data-provide=utypeahead][data-dest=true][data-lob=CARS]");
    private originalPlaceholder: string = this.$input.attr("placeholder") || "City, airport or address";
    private placeholderIndex: number = -1;
    private intervalId: number;
    private timeoutId: number;
    private context: IContext;

    public handlePageLoad(options: any, context: IContext): void {
        $(".car-rental-hint-text").data("hint-order", "random");
        this.$input = $("input[data-provide=utypeahead][data-dest=true][data-lob=CARS]");
        this.context = context;
        CarPlaceholderCycle.variant = 0;
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            if (ExecutionHelper.shouldExecute(context, configurationRandom)) {
                CarPlaceholderCycle.variant = 1;
            }
            this.modifyInputElement(this.$input);
        }
    }

    private modifyInputElement = ($inputElement: JQuery): void => {
        this.$input = $inputElement;
        prefetchInstance.getPrefetchCarRentalHints()
            .done((hints: string[]) => {
                let carRentalHints: string[] = hints;
                if (carRentalHints.length === 0) {
                    // Use the static list as a back up
                    carRentalHints = this.getCarPlaceholders(TypeaheadUtils.getSiteId());
                }

                CarPlaceholderCycle.placeholders = carRentalHints;
                uitk.subscribe("sfSelectedLobs.updated", (topic, data) => {
                    this.stopCyclePlaceholders();
                    if (this.recheckVariant(true) !== 0) {
                        this.startCyclePlaceholders();
                    }
                });
                this.startCyclePlaceholders();
                this.$input.blur(this.startCyclePlaceholders);
                this.$input.focus(this.stopCyclePlaceholders);
            });
    }

    private startCyclePlaceholders = (): void => {
        this.stopCyclePlaceholders();
        if (this.getVariant() !== 0) {
            this.timeoutId = setTimeout(this.cyclePlaceholders, CarPlaceholderCycle.initialDelayMillis);
        }
    }

    private stopCyclePlaceholders = (): void => {
        if (this.intervalId !== undefined) {
            clearInterval(this.intervalId);
        }
        if (this.timeoutId !== undefined) {
            clearTimeout(this.timeoutId);
        }
        this.placeholderIndex = -1;
        this.setPlaceholderText(this.originalPlaceholder);
    }

    private cyclePlaceholders = (): void => {
        this.intervalId = setInterval(this.setNextPlaceholderText, CarPlaceholderCycle.cycleDelayMillis);
    }

    private setPlaceholderText = (text: string): void =>  {
        this.$input.attr("placeholder", text);
        uitk.prepFields();
    }

    private setNextPlaceholderText = (index?: number): void =>  {
        this.setPlaceholderText(this.getNextText(index));
    }

    private getNextIndex = (index?: number): number => {
        if (index === undefined) {
            index = CarPlaceholderCycle.placeholders.length;
        }
        if (this.getVariant() === 1) {
            if (CarPlaceholderCycle.placeholders.length !== 0) {
                index = this.placeholderIndex;
                while (index === this.placeholderIndex) {
                    index = Math.floor(Math.random() * (CarPlaceholderCycle.placeholders.length + 1));
                }
            }
        } else if (this.getVariant() === 2) {
            index = this.placeholderIndex + 1;
            if (this.placeholderIndex > CarPlaceholderCycle.placeholders.length) {
                return 0;
            }
        }
        return index;
    }

    private getNextText = (index?: number): string => {
        if (index === undefined) {
            index = this.getNextIndex();
            this.placeholderIndex = index;
        }
        if (index >= CarPlaceholderCycle.placeholders.length) {
            return this.originalPlaceholder;
        } else {
            return CarPlaceholderCycle.tryPhrase.replace("{0}", CarPlaceholderCycle.placeholders[index]);
        }
    }

    private getVariant = (): number => {
        this.recheckVariant();
        return CarPlaceholderCycle.variant;
    }

    private recheckVariant(force?: boolean): number {
        if (force === undefined) {
            force = false;
        }
        if (force || CarPlaceholderCycle.variant === undefined) {
            if (!ExecutionHelper.shouldExecute(this.context, configuration)) {
                CarPlaceholderCycle.variant = 0;
                return 0;
            }
            if (ExecutionHelper.shouldExecute(this.context, configurationRandom)) {
                CarPlaceholderCycle.variant = 1;
                return 1;
            }
        }
        return 0;
    }

    private getCarPlaceholders(pos: string): string[] {
      let placeholderLocations: string[];

      switch (pos) {
        case "1":
            placeholderLocations = ["Denver Hertz", "Miami Budget", "LAX", "MCO", "San Francisco", "Boston"];
            break;
        case "3":
            placeholderLocations = ["London Europcar", "Miami Sixt", "LON", "DUB", "Heathrow", "Paris"];
            break;
        case "25":
            placeholderLocations = ["Perth Enterprise", "Brisbane Avis", "MEL", "SYD", "Cairns", "London"];
            break;
        case "27":
            placeholderLocations = ["DEL", "HYD", "Bengaluru", "Mumbai"];
            break;
        case "63":
            placeholderLocations = ["Dublin Easirent", "Sydney Europcar", "LAS", "DUB", "London", "Chicago"];
            break;
        case "29":
            placeholderLocations =
                ["Wellington Economy Rent A Car", "Queenstown Europcar", "AKL", "LON", "Sydney", "Auckland"];
            break;
        case "70125":
            placeholderLocations = ["Belfast Sixt", "Brisbane Hertz", "MEL", "SYD", "Melborne", "Las Vegas"];
            break;
        case "70403":
            placeholderLocations = ["Houston Avis", "Boston Dollar", "LON", "DUB", "Paris", "London"];
            break;
        case "70301":
            placeholderLocations = ["Miami Hertz", "Denver National Car Rental", "LAS", "MCO", "Orlando", "San Jose"];
            break;
        case "80001":
            placeholderLocations = ["Tampa Budget", "Atlanta Avis", "MCO", "LAS", "Denver", "Orlando"];
            break;
        case "70201":
            placeholderLocations = ["Denver Hertz", "Miami Budget", "LAX", "MCO", "San Francisco", "Boston"];
            break;

        default:
            placeholderLocations = [];
      }
      return placeholderLocations;
    }
}
